import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { SalesScheduleDashboardComponent } from './sales-schedule-dashboard.component';


const routes: Routes = [
  {
    path: '',
    component: SalesScheduleDashboardComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesScheduleDashboardRoutingModule {
}
